<section 
  class="custom-route__action-buttons"
  [class.compact]="isActionButtonsCompactSignal()"
>
  @if (isActionButtonsCompactSignal()) {
    <app-actions-buttons-compact 
      (startRouteClick)="handleStartRouteClick()"
      (editRouteClick)="handleEditRouteClick()"
      (buyTicketsClick)="handleBuyTicketsClick()"
    />
  } @else {
    <app-actions-buttons-expanded
      (startRouteClick)="handleStartRouteClick()"
      (editRouteClick)="handleEditRouteClick()"
      (buyTicketsClick)="handleBuyTicketsClick()"
    />
  }
</section>